interface FilterBarProps {
  sort: string;
  onSortChange: (sort: string) => void;
  language: string;
  onLanguageChange: (lang: string) => void;
  languages: string[];
}

export function FilterBar({ sort, onSortChange, language, onLanguageChange, languages }: FilterBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-4 mb-6 text-xs">
      <div className="flex items-center gap-2">
        <span className="text-text-muted uppercase tracking-widest text-[10px]">Sort</span>
        <select
          value={sort}
          onChange={(e) => onSortChange(e.target.value)}
          className="bg-transparent border border-border px-2 py-1 text-xs text-text-primary focus:outline-none focus:border-accent/50 font-mono cursor-pointer"
        >
          <option value="stars">Stars</option>
          <option value="forks">Forks</option>
          <option value="updated">Committed</option>
          <option value="name">Name</option>
        </select>
      </div>

      {languages.length > 0 && (
        <div className="flex items-center gap-2">
          <span className="text-text-muted uppercase tracking-widest text-[10px]">Lang</span>
          <select
            value={language}
            onChange={(e) => onLanguageChange(e.target.value)}
            className="bg-transparent border border-border px-2 py-1 text-xs text-text-primary focus:outline-none focus:border-accent/50 font-mono cursor-pointer"
          >
            <option value="">All</option>
            {languages.map((l) => (
              <option key={l} value={l}>{l}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
